module.exports = __webpack_public_path__ + "static/media/RadioMsg.fc1fd54a.jpg";